// Importing modules
import ForceGraph from 'force-graph';
import ForceGraph3D from '3d-force-graph';
// import 'select2';
import { UnrealBloomPass } from 'three-stdlib';
import * as graphStyleModule from './graphStyling.js';
import * as graphologyHelper from './graphologyHelpers.js';
import * as titleHelper from './titleHelper';

import Graph from 'graphology';
import betweennessCentrality from 'graphology-metrics/centrality/betweenness';
import {degreeCentrality} from 'graphology-metrics/centrality/degree';
import data from './data.json';
import localData from './data.json';
// import {findMinMaxAttribute, findMinMaxDates} from "./graphologyHelpers.js";
// import {update} from "three/addons/libs/tween.module";




// let data;
let graph
let isInitialLayoutComplete
// let window.externalInNetwork
window.globalData = data
window.numDim = 2
window.includeExternals = false
// Define a custom event for when the graph engine stops
const graphEngineStoppedEvent = new Event('graphEngineStopped');
// URL of your FastAPI backend (leave empty or null for local data)
const dataUrl = process.env.DATA_URL;
// const dataUrl = 'http://localhost:5009/data?secret_key=C%3C3C6N/%2AI%25%25a%21Pm';
//
function transformData(data) {
    // Helper function to format dates
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toISOString().split('T')[0];
    };

    // Transform nodes
    data.nodes = data.nodes.map(node => ({
        ...node,
        primary_status: node.primary_st,
        affiliations: node.aff_ids.map(id => data.affil_map[id]),
        statuses: node.st_ids.map(id => data.status_map[id]),
        nodeBtwCentrality: node.btw,
        nodeDgrCentrality: node.dgr
    }));

    // Remove old properties and rename dates in links
    data.nodes.forEach(node => {
        delete node.primary_st;
        delete node.aff_ids;
        delete node.st_ids;
        delete node.btw;
        delete node.dgr;
    });

    // Transform links
    data.links = data.links.map(link => ({
        ...link,
        dateInstances: link.dates.map(date => ({
            start: formatDate(date.start),
            end: formatDate(date.end)
        }))
    }));

    // Remove old dates property
    data.links.forEach(link => {
        delete link.dates;
    });

    return data;
}



async function fetchAndProcessData(url) {
    let data;

    try {
        if (url) {
            // Include headers with your secret key
            const response = await fetch(url, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            else{
                // console.info("Established OK response from the backend. YAY!")
                fadeOutOverlay('fetchingDataOverlay')
                // document.getElementById('fetchingDataOverlay').style.display = 'none'
                // document.getElementById('graphProcessingOverlay').style.display = 'flex'
            }
            data = await response.json();
        } else {
            data = localData; // Fallback to local data
        }

        // Process your data here
        window.globalData = transformData(data);
        // window.globalDataGy = graphologyHelper.convertToGraphologyFormat(window.globalData);
        // const graph = new Graph.from(window.globalDataGy, {
        //     multi: true,
        //     allowSelfLoops: false,
        //     type: "undirected"
        // });
        //
        // // Assign centrality metrics
        // betweennessCentrality.assign(graph, {
        //     nodeCentralityAttribute: 'nodeBtwCentrality',
        //     getEdgeWeight: (_, attr) => attr.value,
        //     normalized: true
        // });
        // //(degreeCentrality):
        // degreeCentrality.assign(graph,
        //     {nodeCentralityAttribute: 'nodeDgrCentrality'});
        //
        // window.globalGraphologyData = graph;
        // // Check if window.globalGraphologyData is a Graphology graph instance
        // if (window.globalGraphologyData instanceof Graph) {
        //     window.globalData = graphologyHelper.convertFromGraphologyFormat2(window.globalGraphologyData);
        // } else {
        //     console.error("window.globalGraphologyData is not a Graphology graph instance.");
        // }
        // document.getElementById('graphProcessingOverlay').style.display = 'none'
        document.getElementById('loadingOverlay').style.display = 'flex'
        document.getElementById('sidebar-hider').style.transform = 'translateX(-100%)';
        // document.getElementById('sidebar-hider').style.display = 'none';

    } catch (error) {
        console.error('There was a problem fetching or processing the data:', error);
    }
}


// Call the function to fetch and process the data
$(document).ready(function() {
    initializeSliders()
    // Assuming fetchData is your function to fetch data
    fetchAndProcessData(dataUrl).then(fetchedData => {
        // Now that all processing is done, populate the selectors
        window.dateSlider = graphologyHelper.findMinMaxDates(window.globalData.links)
        window.maxCentralities = graphologyHelper.findMaxCentralities(window.globalData.nodes)
        setupDateSlider(window.dateSlider.minDate,window.dateSlider.maxDate)
        setupCentralitySliders(window.maxCentralities.maxBtw,window.maxCentralities.maxDgr)
        populateSelectors(window.globalData);
        // Any other functions that depend on the DOM being ready
        filterRenderVisualization();
    });
});



function populateSelectors(data) {
    // Any processing of the fetched data before visualization goes here.
    const uniqueStatuses = [...new Set(data.nodes.flatMap(node => node.statuses))];
    uniqueStatuses.forEach(status => {
        if (status!="external"){
            const option = document.createElement("option");
            option.value = status;
            option.text = status;
            document.getElementById("statusSelector").appendChild(option);}
    });

    const uniqueAffiliations = [...new Set(data.nodes.flatMap(node => node.affiliations))];
    uniqueAffiliations.forEach(affiliation => {
        const option = document.createElement("option");
        option.value = affiliation;
        option.text = affiliation;
        document.getElementById("affiliationSelector").appendChild(option);
    });

    const nodes = data.nodes.map(node => ({
        name: node.name,
        id: node.id,
        primary_status: node.primary_status
    }));

    // Filter out nodes with a primary status of 'external' and then map to get name and id
    const filteredNodes = nodes
        .filter(node => node.primary_status !== 'external')
        .map(node => {
            return { name: node.name, id: node.id };
        });

// Sort nodes alphabetically by name
    const sortedNodes = filteredNodes.sort((a, b) => a.name.localeCompare(b.name));

    // Create option elements for each sorted node
    sortedNodes.forEach(node => {
        const option = document.createElement("option");
        option.value = node.id;
        option.text = `${node.name}`// (${node.id})`; // Display text as "name (without id)"
        document.getElementById("searchNodeId").appendChild(option);
    });

    $('#statusSelector').select2({dropdownAutoWidth : true,placeholder: "⟩"});
    $('#affiliationSelector').select2({dropdownAutoWidth : true,placeholder: "⟩"});
    $('#searchNodeId').select2({dropdownAutoWidth : false,minimumInputLength: 5,placeholder: "Start typing a name",
        allowClear: true});
}

function setupCentralitySliders(maxBetweenness, maxDegree){


    const maxBw = maxBetweenness+0.0001
    const maxDg = maxDegree+0.0001

    // betweennessSlider:
    $("#betweennessRangeSlider").slider({
        range: true,
        min: 0, // Set the minimum value for betweenness centrality
        max: maxBw, // Set the maximum value for betweenness centrality
        step: 0.0001, // Set the step value
        values: [0, maxBw], // Initial values
        slide: function (event, ui) {
            const startValue = ui.values[0].toFixed(4);
            const endValue = ui.values[1].toFixed(4);
            $('#betweennessStart').text(startValue);
            $('#betweennessEnd').text(endValue);
        }
    });

    // Initial label setup
    const startBwValue = (0).toFixed(4);
    const endBwValue = maxBw.toFixed(4);
    $('#betweennessStart').text(startBwValue);
    $('#betweennessEnd').text(endBwValue);

    $("#degreeRangeSlider").slider({
        range: true,
        min: 0, // Set the minimum value for degree centrality
        max: maxDg, // Set the maximum value for degree centrality
        step: 0.0001, // Set the step value
        values: [0, maxDg], // Initial values
        slide: function (event, ui) {
            const startValue = ui.values[0].toFixed(4);
            const endValue = ui.values[1].toFixed(4);
            $('#degreeStart').text(startValue);
            $('#degreeEnd').text(endValue);
        }
    });

    // Initial label setup
    const startDgValue = (0).toFixed(4);
    const endDgValue = maxDg.toFixed(4);
    $('#degreeStart').text(startDgValue);
    $('#degreeEnd').text(endDgValue);
}

function setupDateSlider(start,end){
    // dateRangeSlider:
    $("#dateRangeSlider").slider({
        range: true,
        min: start.getTime(),
        max: end.getTime(),
        step: 86400000, // One day in milliseconds
        values: [start.getTime(), end.getTime()],
        slide: function (event, ui) {
            const startDate = new Date(ui.values[0]).toISOString().split('T')[0];
            const endDate = new Date(ui.values[1]).toISOString().split('T')[0];
            $('#startDate').text(startDate);
            $('#endDate').text(endDate);
        }
    });

    // Initial label setup
    const initialStartDate = new Date($("#dateRangeSlider").slider("values", 0)).toISOString().split('T')[0];
    const initialEndDate = new Date($("#dateRangeSlider").slider("values", 1)).toISOString().split('T')[0];
    $('#startDate').text(initialStartDate);
    $('#endDate').text(initialEndDate);
}

function initializeSliders() {
    // dateRangeSlider:
    $("#dateRangeSlider").slider({
        range: true,
        min: new Date('2008-01-01').getTime(),
        max: new Date('2030-12-31').getTime(),
        step: 86400000, // One day in milliseconds
        values: [new Date('2008-01-01').getTime(), new Date('2030-12-31').getTime()],
        slide: function (event, ui) {
            const startDate = new Date(ui.values[0]).toISOString().split('T')[0];
            const endDate = new Date(ui.values[1]).toISOString().split('T')[0];
            $('#startDate').text(startDate);
            $('#endDate').text(endDate);
        }
    });

    // Initial label setup
    const initialStartDate = new Date($("#dateRangeSlider").slider("values", 0)).toISOString().split('T')[0];
    const initialEndDate = new Date($("#dateRangeSlider").slider("values", 1)).toISOString().split('T')[0];
    $('#startDate').text(initialStartDate);
    $('#endDate').text(initialEndDate);

    // betweennessSlider:
    $("#betweennessRangeSlider").slider({
        range: true,
        min: 0, // Set the minimum value for betweenness centrality
        max: 0.1, // Set the maximum value for betweenness centrality
        step: 0.0001, // Set the step value
        values: [0, 0.1], // Initial values
        slide: function (event, ui) {
            const startValue = ui.values[0].toFixed(2);
            const endValue = ui.values[1].toFixed(2);
            $('#betweennessStart').text(startValue);
            $('#betweennessEnd').text(endValue);
        }
    });

    // Initial label setup
    $('#betweennessStart').text("0.0000");
    $('#betweennessEnd').text("0.2000");

    $("#degreeRangeSlider").slider({
        range: true,
        min: 0, // Set the minimum value for degree centrality
        max: 0.1, // Set the maximum value for degree centrality
        step: 0.0001, // Set the step value
        values: [0, 0.1], // Initial values
        slide: function (event, ui) {
            const startValue = ui.values[0];
            const endValue = ui.values[1];
            $('#degreeStart').text(startValue);
            $('#degreeEnd').text(endValue);
        }
    });

    // Initial label setup
    $('#degreeStart').text("0.0000");
    $('#degreeEnd').text("0.2000");
}


function datesOverlap(start1, end1, start2, end2) {
    // Convert to timestamps outside the loop for efficiency
    return Math.max(start1, start2) <= Math.min(end1, end2);
}

function updateLinkWeights(links, startDate, endDate) {
    // Convert the start and end dates to timestamps once, before the loop
    const startTimestamp = startDate.getTime();
    const endTimestamp = endDate.getTime();

    links.forEach(link => {
        let weight = 0;

        link.dateInstances.forEach(instance => {
            // Convert instance dates to timestamps
            const instanceStartTimestamp = new Date(instance.start).getTime();
            const instanceEndTimestamp = new Date(instance.end).getTime();

            if (datesOverlap(instanceStartTimestamp, instanceEndTimestamp, startTimestamp, endTimestamp)) {
                weight++;
            }
        });

        link.value = weight;
    });
}



window.openNav = function() {
    document.getElementById("sidebar").style.width = "250px";
    document.getElementById("main").style.marginLeft = "250px";
    document.getElementById("sidebar").style.padding = "24px 16px"
    // document.getElementById("options-button").style.display="none";
    // document.getElementById("sidebar").style.display = "block";
}

window.closeNav = function() {
    document.getElementById("sidebar").style.width = "0";
    document.getElementById("main").style.marginLeft= "0";
    document.getElementById("sidebar").style.padding = "0px 0px"
    // document.getElementById("options-button").style.display="block"
    // document.getElementById("sidebar").style.display = "none";
}

function toggleRectangle() {
    const rectangle = document.getElementById('expandable-rectangle');
    rectangle.classList.toggle('expanded');

    updateContentVisibility();
}

function updateContentVisibility() {
    const isExpanded = document.getElementById('expandable-rectangle').classList.contains('expanded');
    // Show or hide the content based on expanded state
    document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
        element.style.display = isExpanded ? 'flex' : 'none';
    });
}





document.addEventListener("DOMContentLoaded", function() {
    // Ensure the DOM is fully loaded
    const toggleDimensionSwitch = document.getElementById('toggleDimensionSwitch');
    const toggleExternalSwitch = document.getElementById('toggleExternalSwitch');

    // Reset switches to 'off' state
    toggleDimensionSwitch.checked = false;
    toggleExternalSwitch.checked = false;

    toggleDimensionSwitch.addEventListener('change', function() {
        if(this.checked) {
            // Checkbox is checked, bind the value '3'
            window.numDim = 3;
        } else {
            // Checkbox is not checked, bind the value '2'
            window.numDim = 2;
        }});

    toggleExternalSwitch.addEventListener('change', function() {
        if (this.checked) {
            // Checkbox is checked, bind the value '2'
            window.includeExternals = true;
        } else {
            // Checkbox is not checked, bind the value '3'
            window.includeExternals = false;
        }});

    // document.querySelector('.icon-area').addEventListener('click', toggleRectangle);
    // document.querySelector('#search-button').addEventListener('click', toggleRectangle);
    // Initial call to set the visibility based on the current state
    updateContentVisibility();

    // Attach the event listener to the icon-area or the specific element intended for toggling
    document.querySelector('.icon-area').addEventListener('click', toggleRectangle);
    document.querySelector('#search-button').addEventListener('click', toggleRectangle);

    // If you have a specific button to collapse the rectangle, ensure it's set up here as well
    document.querySelector('#search-button').addEventListener('click', function(event) {
        event.stopPropagation(); // Prevent the click from bubbling up to the rectangle
    });
});

document.addEventListener("graphEngineStopped", function() {
    let kpi1 =  window.filteredData.links.filter(link => (link.value>0)).length;
    let kpi2 = window.filteredData.links.filter(link => (link.source.primary_status==="external" ^ link.target.primary_status==="external")).length;
    let kpi3 = window.filteredData.nodes.filter(node => node.primary_status === "external").length;

    let kpi4 = window.filteredData.nodes.filter(node => node.primary_status !== "external").length;
    let kpi5 = window.filteredData.links.filter(link => (link.source.primary_status!=="external" && link.target.primary_status!=="external")).length;


    animateValue("numEdges", 0, kpi1, 1000);
    animateValue("numExternalEdges", 0, kpi2, 1000);
    animateValue("numExternalNodes", 0, kpi3, 1000);
    animateValue("numInternalNodes", 0, kpi4, 1000);
    animateValue("numInternalEdges", 0, kpi5, 1000);
});

function animateValue(id, start, end, duration) {
    let range = Math.abs(end - start);
    let current = start;
    let stepTime = 10; // Time per step in milliseconds
    let steps = duration / stepTime; // Total number of steps
    let increment = range / steps * (end > start ? 1 : -1);

    let obj = document.getElementById(id);
    let timer = setInterval(function() {
        current += increment;
        // Ensure that the final value is exactly 'end'
        if ((increment > 0 && current > end) || (increment < 0 && current < end)) {
            current = end;
        }
        obj.innerHTML = Math.round(current);
        if (current === end) {
            clearInterval(timer);
        }
    }, stepTime);
}

window.filterRenderVisualization = function() {
    // Retrieve slider values
    let selectedStartDate, selectedEndDate, btw1, btw2, dgr1, dgr2;
    // ... slider retrieval logic ...
    if ($("#dateRangeSlider").hasClass('ui-slider') &&
        $("#betweennessRangeSlider").hasClass('ui-slider') &&
        $("#degreeRangeSlider").hasClass('ui-slider')) {
        selectedStartDate = new Date($("#dateRangeSlider").slider("values", 0));
        selectedEndDate = new Date($("#dateRangeSlider").slider("values", 1));
        btw1 = ($("#betweennessRangeSlider").slider("values", 0));
        btw2 = ($("#betweennessRangeSlider").slider("values", 1));
        dgr1 = ($("#degreeRangeSlider").slider("values", 0));
        dgr2 = ($("#degreeRangeSlider").slider("values", 1));
    } else {
        console.error("Sliders are not initialized.");
        return; // Exit the function if sliders are not initialized
    }

    document.getElementById('loadingOverlay').style.display = 'flex';



    let dataToFilter = JSON.parse(JSON.stringify(window.globalData));

    // Update node affiliations for external nodes
    dataToFilter.nodes.forEach(node => {
        if (node.primary_status === "external") {
            node.affiliations = ["external"];
        }
    });

    // Initial layout flag
    isInitialLayoutComplete = false;

    // Retrieve selected statuses and affiliations
    let selectedStatuses = Array.from(document.getElementById("statusSelector").selectedOptions).map(opt => opt.value);
    let selectedAffiliations = Array.from(document.getElementById("affiliationSelector").selectedOptions).map(opt => opt.value);

    window.externalInNetwork = window.includeExternals === true;



    const isAnyStatusSelected = selectedStatuses.filter(status => status !== "external").length > 0;
    const isAnyAffiliationSelected = selectedAffiliations.filter(affiliation => affiliation !== "external").length > 0;

    // Update link weights based on the selected date range
    updateLinkWeights(dataToFilter.links, selectedStartDate, selectedEndDate);

    // Get those nodes who are not external partners and in the scope
    const filteredCoreNodes = dataToFilter.nodes.filter(node => {
        // const isWithinBtwRange = true
        // const isWithinDgrRange = true
        const isWithinBtwRange = node.nodeBtwCentrality >= btw1 && node.nodeBtwCentrality <= btw2;
        const isWithinDgrRange = node.nodeDgrCentrality >= dgr1 && node.nodeDgrCentrality <= dgr2;

        // Previous conditions...
        const isInternal = node.primary_status!=="external";
        const isStatusSelected = !isAnyStatusSelected || selectedStatuses.some(status => node.statuses.includes(status));
        const isAffiliationSelected = !isAnyAffiliationSelected || selectedAffiliations.some(affiliation => node.affiliations.includes(affiliation));

        return isWithinBtwRange && isWithinDgrRange && isInternal && isStatusSelected && isAffiliationSelected;
    });

    // Get those external nodes who are in the scope
    const filteredExternalNodes = dataToFilter.nodes.filter(node => {
        const isWithinBtwRange = true //node.nodeBtwCentrality >= btw1 && node.nodeBtwCentrality <= btw2;
        const isWithinDgrRange = true //node.nodeDgrCentrality >= dgr1 && node.nodeDgrCentrality <= dgr2;

        const isExternal = node.primary_status==="external";

        return isWithinBtwRange && isWithinDgrRange && isExternal;
    });


    const coreNodeIds = new Set(filteredCoreNodes.map(node => node.id));
    const externalNodeIds = new Set(filteredExternalNodes.map(node => node.id));


    // Get graph links which are relevant
    const filteredCoreLinks =  dataToFilter.links.filter(link => {
        return coreNodeIds.has(link.target) && coreNodeIds.has(link.source) && link.value>0
    });

    const filteredExternalLinks = dataToFilter.links.filter(link => {
        const containsCoreNode = coreNodeIds.has(link.target) || coreNodeIds.has(link.source)
        const containsExternalNode = externalNodeIds.has(link.target) || externalNodeIds.has(link.source)

        return containsCoreNode && containsExternalNode && link.value > 0
    });
    const participantCoreTargetIds = new Set(filteredCoreLinks.map(link => link.target))
    const participantCoreSourceIds = new Set(filteredCoreLinks.map(link => link.source))
    const participantCoreNodeIds = new Set([...participantCoreTargetIds, ...participantCoreSourceIds]);
    const participantTargetIds = new Set(filteredExternalLinks.map(link => link.target))
    const participantSourceIds = new Set(filteredExternalLinks.map(link => link.source))
    const participantNodeIds = new Set([...participantTargetIds, ...participantSourceIds]);

    // External partners who are connected to internals-in-scope
    const relevantExternalNodes = filteredExternalNodes.filter(node => {
        return participantNodeIds.has(node.id)
    })

    // Internal partners who are not "loners"
    const prunedCoreNodes = filteredCoreNodes.filter(node => {
        return participantCoreNodeIds.has(node.id)
    })


    let filteredData;

    if (!window.externalInNetwork) {
        // core Graph : only internal connections only those nodes who are connected to at least one other
        filteredData = {
            nodes: prunedCoreNodes,
            links: filteredCoreLinks
        };
    }
    else {
        const allNodes = filteredCoreNodes.concat(relevantExternalNodes)
        const prunedNodes = allNodes.filter(node => {
            return participantNodeIds.has(node.id) || participantCoreNodeIds.has(node.id)
        })

        filteredData = {
            nodes: prunedNodes,
            links: filteredCoreLinks.concat(filteredExternalLinks)
        };
    }


    filteredData.links.forEach(link => {
        const a = filteredData.nodes.find(node => node.id === link.source);
        const b = filteredData.nodes.find(node => node.id === link.target);


        !a.neighbors && (a.neighbors = []);
        !b.neighbors && (b.neighbors = []);
        a.neighbors.push(b);
        b.neighbors.push(a);

        !a.links && (a.links = []);
        !b.links && (b.links = []);
        a.links.push(link);
        b.links.push(link);

    });


    window.filteredData = filteredData;

    // Re-render the visualization with the filtered data
    renderGraph(filteredData);
    window.filteredData = filteredData;

}



function renderGraph(data) {
    // Clean the #visualization div
    // document.getElementById('visualization').innerHTML = '';

    if (window.numDim === 2) {
        graphStyleModule.updateLegend(false)
        renderVisualization2d(data);
        window.searchAndZoomFunc = window.searchAndZoomOnNode2d
    } else {
        graphStyleModule.updateLegend(true)
        renderVisualization3d(data);  // Assuming 'data' is globally available
        window.searchAndZoomFunc = window.searchAndZoomOnNode3d
    }

}

function getOpacity(numLinks) {
    // Handle the special case of 0 links
    if (numLinks === 0) return 0.8;

    // Use the logarithmic formula to calculate opacity
    const a = -0.07977;
    const b = 0.8;
    return a * Math.log(numLinks) + b;
}

function renderVisualization2d(data){
    // Define a variable to keep track of the timeout
    let hoverTimeout;
    const elem = document.getElementById('visualization');
    const maxLinkValue = Math.max(...data.links.map(link => link.value))
    const sumOfValues = data.links.reduce((accumulator, link) => accumulator + link.value, 0)+2;
    const opacity = getOpacity(sumOfValues)

    const highlightNodes = new Set();
    const highlightLinks = new Set();
    let hoverNode = null;

    const NODE_R = 2;

    const element = document.getElementById("parentContainer");
    const style = window.getComputedStyle(element);
    const width = style.width; // This will be a string with "px" at the end, e.g. "1200px"
    const widthInPixels = parseInt(width, 10); // Converts the string to an integer
    const height = style.height; // This will be a string with "px" at the end, e.g. "1200px"
    const heightInPixels = parseInt(height, 10); // Converts the string to an integer

    if (!isInitialLayoutComplete && data.nodes.length<250) {
        document.dispatchEvent(graphEngineStoppedEvent);
        isInitialLayoutComplete = true;
        document.getElementById('loadingOverlay').style.display = 'none';
    }

    // Create the graph
    const Graph = ForceGraph()(elem)
        .backgroundColor('#000003')
        .width(widthInPixels)
        .height(heightInPixels)
        .graphData(data)
        .nodeRelSize(NODE_R)
        .nodeColor(node => graphStyleModule.getNodeColor2d(node))
        .nodeLabel(node => `${node.name}`)
        // .linkWidth(link => (link.value / maxLinkValue))
        .linkColor(() => 'rgba(108,108,108,0.42)')
        .linkVisibility(false)


    Graph
        .onNodeClick(node => {

            Graph.enablePointerInteraction(false);

            // Center/zoom on node
            Graph.centerAt(node.x, node.y, 5000)
            Graph.zoom(4, 5000);

            setTimeout(() => {
                Graph.enablePointerInteraction(true);
            }, 5000); // Adjust the delay here as needed


        });

    Graph
        .d3Force('link')
        .distance(link => 1/(link.value / maxLinkValue))

    Graph
        .d3Force('center')
        .strength(0.1)

    Graph.onNodeHover(node => {
        const infoBoxName = document.getElementById('info-box-name');
        const infoBoxDetails = document.getElementById('info-box-details');
        const infoSearchBox = document.getElementById('expandable-rectangle')

        infoSearchBox.classList.remove('expanded');
        document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
            element.style.display =  'none';
        });

        // Clear any existing timeout to prevent multiple triggers
        clearTimeout(hoverTimeout);

        highlightNodes.clear();
        highlightLinks.clear();
        if (node) {
            highlightNodes.add(node);
            node.neighbors.forEach(neighbor => highlightNodes.add(neighbor));
            node.links.forEach(link => highlightLinks.add(link));

            // Construct the content string or HTML
            let infoBoxNameContent = `<strong>${node.name}</strong>`;
            let infoBoxDetailsContent = `
            primary status: <strong>${node.primary_status.replace("phd_", "PhD ")}</strong><br>
            degree centrality: <strong>${node.nodeBtwCentrality.toFixed(4)}</strong><br>
            betweenness centrality: <strong>${node.nodeDgrCentrality.toFixed(4)}</strong><br>
            contacts <br>`;

            infoBoxDetailsContent += graphStyleModule.generateNeighborInfoBoxContent(node, graphStyleModule.getNodeColor2d)

            // Insert the content into the info box and make it visible
            infoBoxName.style.backgroundColor = graphStyleModule.getNodeColor2d(node)
            infoBoxName.style.color = graphStyleModule.getContrastYIQ(graphStyleModule.getNodeColor2d(node))
            infoBoxName.innerHTML = infoBoxNameContent;
            infoBoxDetails.innerHTML = infoBoxDetailsContent;

            // Insert the expandable rectangle first
            infoBoxDetails.appendChild(infoSearchBox);

        } else {
            const infoSearchBox = document.getElementById('expandable-rectangle')

            hoverTimeout = setTimeout(() => {
                // If no node is hovered, hide the info box after a delay
                infoBoxName.style.backgroundColor = "#252527";
                infoBoxName.style.color = "#F6F6F6";
                infoBoxName.innerHTML = "No node selected";
                infoBoxDetails.innerHTML = "Hover over a node to see more details";
                infoBoxDetails.appendChild(infoSearchBox);
            }, 2000); // Delay in milliseconds, adjust as needed
        }

        hoverNode = node || null;
    })
        .onLinkHover(link => {
            highlightNodes.clear();
            highlightLinks.clear();

            if (link) {
                highlightLinks.add(link);
                highlightNodes.add(link.source);
                highlightNodes.add(link.target);
            }
        })
        .autoPauseRedraw(false) // keep redrawing after engine has stopped
        .linkWidth(link => highlightLinks.has(link) ? 5 : 1)
        .linkVisibility(link => highlightLinks.has(link) ? true : false)
        .nodeCanvasObjectMode(node => highlightNodes.has(node) ? 'before' : undefined)
        .nodeCanvasObject((node, ctx) => {
            // add ring just for highlighted nodes
            ctx.beginPath();
            ctx.arc(node.x, node.y, NODE_R * 1.4, 0, 2 * Math.PI, false);
            ctx.fillStyle = node === hoverNode ? '#EDF115' : '#1FFFD7';
            ctx.fill();
        });


    Graph.enableNodeDrag(false)


    // Graph.onEngineStop(() => Graph.linkVisibility(true))
    Graph.onEngineStop(() => {
        if (!isInitialLayoutComplete) {
            document.dispatchEvent(graphEngineStoppedEvent);
            isInitialLayoutComplete = true;
            fadeOutOverlay('loadingOverlay')
            // document.getElementById('loadingOverlay').style.display = 'none';
        }
    });

    window.searchAndZoomOnNode2d = function() {

        const nodeId = document.getElementById('searchNodeId').value;

        // Assuming node IDs are strings. If they are numbers, use '==='. Adjust accordingly.
        const node = data.nodes.find(n => n.id === parseInt(nodeId));

        if (node) {
            const infoBoxName = document.getElementById('info-box-name');
            const infoBoxDetails = document.getElementById('info-box-details');
            const infoSearchBox = document.getElementById('expandable-rectangle')

            infoSearchBox.classList.remove('expanded');
            document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
                element.style.display =  'none';
            });

            Graph.enablePointerInteraction(false);


            Graph.centerAt(node.x, node.y, 5000)
            Graph.zoom(4, 5000);

            highlightNodes.add(node);
            node.neighbors.forEach(neighbor => highlightNodes.add(neighbor));
            node.links.forEach(link => highlightLinks.add(link));

            setTimeout(() => {
                Graph.enablePointerInteraction(true);
            }, 5000); // Adjust the delay here as needed

            // Construct the content string or HTML
            let infoBoxNameContent = `<strong>${node.name}</strong>`;
            let infoBoxDetailsContent = `
            primary status: <strong>${node.primary_status.replace("phd_", "PhD ")}</strong><br>
            degree centrality: <strong>${node.nodeBtwCentrality.toFixed(4)}</strong><br>
            betweenness centrality: <strong>${node.nodeDgrCentrality.toFixed(4)}</strong><br>
            contacts <br>`;

            infoBoxDetailsContent += graphStyleModule.generateNeighborInfoBoxContent(node, graphStyleModule.getNodeColor2d)

            // Insert the content into the info box and make it visible
            infoBoxName.style.backgroundColor = graphStyleModule.getNodeColor2d(node)
            infoBoxName.style.color = graphStyleModule.getContrastYIQ(graphStyleModule.getNodeColor2d(node))
            infoBoxName.innerHTML = infoBoxNameContent;
            infoBoxDetails.innerHTML = infoBoxDetailsContent;

            // Insert the expandable rectangle first
            infoBoxDetails.appendChild(infoSearchBox);

            infoSearchBox.classList.remove('expanded');
            document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
                element.style.display =  'none';
            });

        } else {
            alert('Node not found!');
        }
    };
}

function renderVisualization3d(data){

    let hoverTimeout;
    const elem = document.getElementById('visualization');
    const maxLinkValue = Math.max(...data.links.map(link => link.value))
    const sumOfValues = data.links.reduce((accumulator, link) => accumulator + link.value, 0)+2;
    const opacity = getOpacity(sumOfValues)

    const bloomPass = new UnrealBloomPass();
    bloomPass.strength = 7;
    bloomPass.radius = 0.7;
    bloomPass.threshold = 0;


    const highlightNodes = new Set();
    const highlightLinks = new Set();
    let hoverNode = null;

    const element = document.getElementById("parentContainer");
    const style = window.getComputedStyle(element);
    const width = style.width; // This will be a string with "px" at the end, e.g. "1200px"
    const widthInPixels = parseInt(width, 10); // Converts the string to an integer
    const height = style.height; // This will be a string with "px" at the end, e.g. "1200px"
    const heightInPixels = parseInt(height, 10); // Converts the string to an integer

    if (!isInitialLayoutComplete && data.nodes.length<250) {
        document.dispatchEvent(graphEngineStoppedEvent);
        isInitialLayoutComplete = true;
        document.getElementById('loadingOverlay').style.display = 'none';
    }


    // Create the graph
    const Graph = ForceGraph3D()(elem)
        .backgroundColor('#000003')
        .width(widthInPixels)
        .height(heightInPixels)
        // .height("auto")
        .nodeResolution(8)
        .graphData(data)
        .nodeRelSize(1)
        // .nodeAutoColorBy('primary_status')
        .nodeColor(node => graphStyleModule.getNodeColor3d(node))
        .nodeLabel(node => `${node.name}`)
        .linkWidth(link => (link.value / maxLinkValue))
        .numDimensions(3)

    Graph
        .d3Force('link')
        .distance(link => 1/(link.value / maxLinkValue))

    Graph
        .d3Force('center')
        .strength(0.01)

    Graph
        .d3Force('charge')
        .strength(100)

    Graph.enableNodeDrag(false)


    Graph
        .linkVisibility(link => highlightLinks.has(link) ? true : false)
        .numDimensions(3) // Re-heat
        .onNodeClick(node => {
            Graph.enablePointerInteraction(false)
            // Aim at node from outside it
            const distance = 40;
            const distRatio = 1 + distance/Math.hypot(node.x, node.y, node.z);

            const newPos = node.x || node.y || node.z
                ? { x: node.x * distRatio, y: node.y * distRatio, z: node.z * distRatio }
                : { x: 0, y: 0, z: distance }; // special case if node is in (0,0,0)

            Graph.cameraPosition(
                newPos, // new position
                node, // lookAt ({ x, y, z })
                10000  // ms transition duration
            )
            setTimeout(() => {
                Graph.enablePointerInteraction(true);
            }, 10000); // Adjust the delay here as needed
        })

    Graph
        .onNodeHover(node => {
        // no state change
        if ((!node && !highlightNodes.size) || (node && hoverNode === node)) return;

        const infoBoxName = document.getElementById('info-box-name');
        const infoBoxDetails = document.getElementById('info-box-details');
        const infoSearchBox = document.getElementById('expandable-rectangle')

        infoSearchBox.classList.remove('expanded');
        document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
            element.style.display =  'none';
        });


        // Clear any existing timeout to prevent multiple triggers
        clearTimeout(hoverTimeout);

        highlightNodes.clear();
        highlightLinks.clear();

        if (node) {
            highlightNodes.add(node);
            node.neighbors.forEach(neighbor => highlightNodes.add(neighbor));
            node.links.forEach(link => highlightLinks.add(link));

            // Construct the content string or HTML
            let infoBoxNameContent = `<strong>${node.name}</strong>`;
            let infoBoxDetailsContent = `
            primary status: <strong>${node.primary_status.replace("phd_", "PhD ")}</strong><br>
            degree centrality: <strong>${node.nodeBtwCentrality.toFixed(4)}</strong><br>
            betweenness centrality: <strong>${node.nodeDgrCentrality.toFixed(4)}</strong><br>
            contacts <br>`;

            infoBoxDetailsContent += graphStyleModule.generateNeighborInfoBoxContent(node, graphStyleModule.getNodeColor3d)

            // Insert the content into the info box and make it visible
            infoBoxName.style.backgroundColor = graphStyleModule.getNodeColor3d(node)
            infoBoxName.style.color = graphStyleModule.getContrastYIQ(graphStyleModule.getNodeColor3d(node))
            infoBoxName.innerHTML = infoBoxNameContent;
            infoBoxDetails.innerHTML = infoBoxDetailsContent;
            // Insert the expandable rectangle first
            infoBoxDetails.appendChild(infoSearchBox);

        } else {
            hoverTimeout = setTimeout(() => {
                // If no node is hovered, hide the info box after a delay
                infoBoxName.style.backgroundColor = "#252527";
                infoBoxName.style.color = "#F6F6F6";
                infoBoxName.innerHTML = "No node selected";
                infoBoxDetails.innerHTML = "Hover over a node to see more details";
                // Insert the expandable rectangle first
                infoBoxDetails.appendChild(infoSearchBox);
            }, 2000); // Delay in milliseconds, adjust as needed
        }

        hoverNode = node || null;

        updateHighlight();
    })
        .onLinkHover(link => {
            highlightNodes.clear();
            highlightLinks.clear();

            if (link) {
                highlightLinks.add(link);
                highlightNodes.add(link.source);
                highlightNodes.add(link.target);
            }

            updateHighlight();
        });

    Graph.postProcessingComposer().addPass(bloomPass);
    // fit to canvas when engine stops
    // Graph.onEngineStop(() => Graph.zoomToFit(1000));
    Graph.onEngineStop(() => {
        if (!isInitialLayoutComplete) {
            document.dispatchEvent(graphEngineStoppedEvent);
            isInitialLayoutComplete = true;
            fadeOutOverlay('loadingOverlay')
            // document.getElementById('loadingOverlay').style.display = 'none';
        }
    });

    function updateHighlight() {
        // trigger update of highlighted objects in scene
        Graph
            // .linkOpacity(0.5)
            // .linkVisibility(true)
            .nodeColor(Graph.nodeColor())
            .linkWidth(Graph.linkWidth())
            .linkDirectionalParticles(Graph.linkDirectionalParticles());
    }

    window.searchAndZoomOnNode3d = function() {
        const nodeId = document.getElementById('searchNodeId').value;

        // Assuming node IDs are strings. If they are numbers, use '==='. Adjust accordingly.
        const node = data.nodes.find(n => n.id === parseInt(nodeId));

        if (node) {
            const infoBoxName = document.getElementById('info-box-name');
            const infoBoxDetails = document.getElementById('info-box-details');
            const infoSearchBox = document.getElementById('expandable-rectangle')

            infoSearchBox.classList.remove('expanded');
            document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
                element.style.display =  'none';
            });


            Graph.enablePointerInteraction(false)

            // Zoom to the node using the logic you've already provided
            const distance = 40;
            const distRatio = 1 + distance / Math.hypot(node.x, node.y, node.z);

            const newPos = node.x || node.y || node.z
                ? {x: node.x * distRatio, y: node.y * distRatio, z: node.z * distRatio}
                : {x: 0, y: 0, z: distance};

            Graph.cameraPosition(
                newPos,
                node,
                10000
            );

            setTimeout(() => {
                Graph.enablePointerInteraction(true);
            }, 10000); // Adjust the delay here as needed

            highlightNodes.add(node);
            node.neighbors.forEach(neighbor => highlightNodes.add(neighbor));
            node.links.forEach(link => highlightLinks.add(link));

            hoverNode = node || null;

            updateHighlight();

            // Construct the content string or HTML
            let infoBoxNameContent = `<strong>${node.name}</strong>`;
            let infoBoxDetailsContent = `
            primary status: <strong>${node.primary_status.replace("phd_", "PhD ")}</strong><br>
            degree centrality: <strong>${node.nodeBtwCentrality.toFixed(4)}</strong><br>
            betweenness centrality: <strong>${node.nodeDgrCentrality.toFixed(4)}</strong><br>
            contacts <br>`;

            infoBoxDetailsContent += graphStyleModule.generateNeighborInfoBoxContent(node, graphStyleModule.getNodeColor2d)

            // Insert the content into the info box and make it visible
            infoBoxName.style.backgroundColor = graphStyleModule.getNodeColor2d(node)
            infoBoxName.style.color = graphStyleModule.getContrastYIQ(graphStyleModule.getNodeColor2d(node))
            infoBoxName.innerHTML = infoBoxNameContent;
            infoBoxDetails.innerHTML = infoBoxDetailsContent;

            // Insert the expandable rectangle first
            infoBoxDetails.appendChild(infoSearchBox);

            infoSearchBox.classList.remove('expanded');
            document.querySelectorAll('#expandable-rectangle .sidebar-item, #expandable-rectangle button').forEach(element => {
                element.style.display =  'none';
            });




        } else {
            alert('Node not found!');
        }
    };
}

function fadeOutOverlay(overlayId) {
    var overlay = document.getElementById(overlayId);
    overlay.style.opacity = '0'; // Start the fade-out

    // Wait for the transition to finish before setting display to none
    setTimeout(function() {
        overlay.style.display = 'none';
        overlay.style.opacity = '1'
    }, 750); // This duration should match the CSS transition duration
}

// Call this function when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    titleHelper.generateTitle('title-svg-container'); // Assuming you have a div with id 'svg-container'
});

// function setupCanvasDrawing() {
//     // Use class selector to target the specific canvas
//     const canvas = document.querySelector('canvas');
//     if (!canvas) return; // Exit if canvas is not found
//
//     const ctx = canvas.getContext('webgl');
//     let lastX, lastY, moving = false;
//
//     function fadeCanvas() {
//         ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
//         ctx.fillRect(0, 0, canvas.width, canvas.height);
//         requestAnimationFrame(fadeCanvas);
//     }
//
//     document.addEventListener('mousemove', (e) => {
//         if (!moving) return; // Skip if not moving
//
//         const rect = canvas.getBoundingClientRect();
//         const x = e.clientX - rect.left;
//         const y = e.clientY - rect.top;
//
//         ctx.beginPath();
//         ctx.moveTo(lastX, lastY);
//         ctx.lineTo(x, y);
//         ctx.strokeStyle = '#39FF14';
//         ctx.lineWidth = 2;
//         ctx.stroke();
//
//         lastX = x;
//         lastY = y;
//
//         setTimeout(() => { moving = false; }, 100);
//     });
//
//     document.addEventListener('mouseover', (e) => {
//         if (e.target === canvas) moving = true;
//     });
//
//     document.addEventListener('mouseout', (e) => {
//         if (e.target === canvas) moving = false;
//     });
//
//     fadeCanvas(); // Start the fade effect
// }
